/**
 * Pantalla final de confirmación y próximos pasos
 * 
 * @author Ana Lizcano
 */

import React from 'react';
import { CheckCircle, Mail, Clock, Users } from 'lucide-react';
import { getTotalQuestions } from '../data/lazyQuestions';

const CompletionScreen = () => {
  const totalQuestions = getTotalQuestions();
  const totalBlocks = 4;
  return (
    <div className="bg-white rounded-lg shadow-lg p-8 max-w-3xl mx-auto">
      <div className="text-center mb-8">
        <div className="inline-flex items-center justify-center w-20 h-20 bg-green-100 rounded-full mb-6">
          <CheckCircle className="w-12 h-12 text-green-600" />
        </div>
        <h1 className="text-3xl font-bold text-gray-900 mb-4">
          ¡Muchas Gracias por tu Participación!
        </h1>
        <p className="text-lg text-gray-600">
          Has completado exitosamente el test de evaluación
        </p>
      </div>

      <div className="bg-green-50 border border-green-200 rounded-lg p-6 mb-8">
        <h2 className="text-xl font-semibold text-green-900 mb-3">
          Test Completado Exitosamente
        </h2>
        <p className="text-green-800">
          Tus respuestas han sido enviadas correctamente a la empresa. 
          Los resultados serán analizados y considerados como parte del proceso de selección.
        </p>
      </div>

      <div className="mb-8">
        <h2 className="text-xl font-semibold text-gray-900 mb-6">
          ¿Qué sigue ahora?
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="flex items-start space-x-4">
            <div className="bg-blue-100 p-2 rounded-lg">
              <Users className="w-6 h-6 text-blue-600" />
            </div>
            <div>
              <h3 className="font-semibold text-gray-900 mb-1">
                Revisión por el Equipo
              </h3>
              <p className="text-sm text-gray-600">
                Nuestro equipo de recursos humanos revisará tus respuestas junto con tu perfil.
              </p>
            </div>
          </div>

          <div className="flex items-start space-x-4">
            <div className="bg-purple-100 p-2 rounded-lg">
              <Clock className="w-6 h-6 text-purple-600" />
            </div>
            <div>
              <h3 className="font-semibold text-gray-900 mb-1">
                Tiempo de Respuesta
              </h3>
              <p className="text-sm text-gray-600">
                Te contactaremos en los próximos días con información sobre el siguiente paso.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-gray-50 rounded-lg p-6 mb-8">
        <div className="flex items-center space-x-3 mb-4">
          <Mail className="w-5 h-5 text-gray-600" />
          <h3 className="font-semibold text-gray-900">
            ¿Tienes preguntas?
          </h3>
        </div>
        <p className="text-gray-600 mb-3">
          Si tienes alguna pregunta sobre el proceso o necesitas más información, 
          no dudes en contactarnos.
        </p>
        <p className="text-sm text-gray-500">
          Responderemos a tu consulta en un plazo máximo de 48 horas.
        </p>
      </div>

      <div className="border-t border-gray-200 pt-6">
        <h3 className="text-lg font-semibold text-gray-900 mb-4">
          Resumen de tu Participación
        </h3>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-center">
          <div className="bg-blue-50 p-4 rounded-lg">
            <div className="text-2xl font-bold text-blue-600">{totalQuestions}</div>
            <div className="text-sm text-blue-700">Preguntas</div>
            <div className="text-sm text-blue-700">Respondidas</div>
          </div>
          <div className="bg-green-50 p-4 rounded-lg">
            <div className="text-2xl font-bold text-green-600">{totalBlocks}</div>
            <div className="text-sm text-green-700">Bloques</div>
            <div className="text-sm text-green-700">Completados</div>
          </div>
          <div className="bg-purple-50 p-4 rounded-lg">
            <div className="text-2xl font-bold text-purple-600">100%</div>
            <div className="text-sm text-purple-700">Test</div>
            <div className="text-sm text-purple-700">Completado</div>
          </div>
          <div className="bg-orange-50 p-4 rounded-lg">
            <div className="text-2xl font-bold text-orange-600">✓</div>
            <div className="text-sm text-orange-700">Datos</div>
            <div className="text-sm text-orange-700">Enviados</div>
          </div>
        </div>
      </div>

      <div className="text-center mt-8 pt-6 border-t border-gray-200">
        <p className="text-gray-600">
          ¡Gracias por tu tiempo y por estar interesado/a en formar parte de nuestro equipo!
        </p>
        <p className="text-sm text-gray-500 mt-2">
          Puedes cerrar esta ventana de manera segura
        </p>
      </div>
    </div>
  );
};

export default CompletionScreen;